import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FIELD_ERROR_MESSAGES } from '../consts/field-error-messages.const';
import { LocaleService } from '../services/locale.service';
import { PATTERN } from '../consts/pattern.const';

@Pipe({
  name: 'errorMessage',
  pure: false,
  standalone: true
})
export class ErrorMessagePipe implements PipeTransform {
  patterns: Record<string, () => string> = {
    password: () => FIELD_ERROR_MESSAGES.password
  };

  fieldErrors: Record<string, (pattern?: string) => string> = {
    required: () => FIELD_ERROR_MESSAGES.required,
    invalidAutocomplete: () => FIELD_ERROR_MESSAGES.invalidAutocomplete,
    invalidValue: () => FIELD_ERROR_MESSAGES.invalidValue,
    pattern: (pattern?: string) => (pattern && this.patterns[pattern] ? this.patterns[pattern]() : FIELD_ERROR_MESSAGES.default),
    fullName: () => FIELD_ERROR_MESSAGES.fullName
  };

  constructor(private localeService: LocaleService) {}

  transform(name: string, form: UntypedFormGroup): string | void {
    for (const errorName in form.get(name)?.errors) {
      let patternKey;
      if (errorName === 'pattern') {
        const requiredPattern = form.get(name)?.errors?.pattern.requiredPattern;
        const patternValue = Object.values(PATTERN).find((pattern) => String(pattern) === requiredPattern);
        if (patternValue) {
          patternKey = Object.keys(PATTERN).find((key) => PATTERN[key] === patternValue);
        }
      }

      const errorText = this.fieldErrors[errorName] ? this.fieldErrors[errorName](patternKey) : FIELD_ERROR_MESSAGES.default;
      return this.localeService.getString(errorText);
    }
  }
}
